// Opt-in/out State
export const OPTED_IN_STORAGE_KEY = 'rpr_opted_in';

// FIXME: storage keyにtokenを入れた方が良い？
export const USER_ID_STORAGE_KEY = 'rpr_uid';
export const DEFAULT_INTERVAL_DAYS_TO_STORAGE_EXPIRATION = 365 * 2; // 2 years
export const SILVER_EGG_UID_STORAGE_KEY = 'rpr_silver_egg_uid_key';

// Session
export const CURRENT_SESSION_STARTED_AT_STORAGE_KEY = 'rpr_session_started_at';
export const IS_FIRST_SESSION_STORAGE_KEY = 'rpr_is_first_session';
export const LAST_EVENT_TRACKED_AT_STORAGE_KEY = 'rpr_event_last_tracked_at';
export const DEFAULT_SESSION_EXPIRY_INTERVAL = 30 * 60000; // 30 minutes
export const SESSION_INHERITANCE_EXPIRATION_LIMIT = 60 * 60 * 1000; // 1 hour

// User ID
export const USER_ID_LENGTH_MAX = 191; // Max char length of context.user_annotation

// overall validation
export const INVALID_STRING_VALUES = ['null', 'undefined', 'NaN', 'true', 'false'];

// Event
export const EVENT_NAME_LENGTH_MAX = 191; // Max size of unique index of MySQL. 767 bytes / 4 bytes as UTF32.
export const EVENT_PROPERTIES_MAX = 20; // For more details, see https://repro.esa.io/posts/8722
export const EVENT_PROPERTY_NAME_MAX = 48; // For more details, see https://repro.esa.io/posts/8722#comment-332818
export const EVENT_PROPERTY_VALUE_MAX = 191; // 単一のDBカラムに保存するわけではないのでシステム的な制限はないものの、あまり長い文字列を指定できるメリットもないので EVENT_NAME_LENGTH_MAX に合わせてある
export const STANDARD_EVENT_PREFIX = '___repro___';
export const STANDARD_EVENT_NAME = (name: string) => `${STANDARD_EVENT_PREFIX}${name}`;

// User Profile
export const USER_PROFILE_KEY_LENGTH_MAX = 255; // Max size of varchar(255) COLLATE utf8mb4_bin
export const USER_PROFILE_VALUE_LENGTH_MAX = 255;
export const STANDARD_USER_PROFILE_PREFIX = '___repro___';
export const STANDARD_USER_PROFILE_NAME = (name: string) => `${STANDARD_USER_PROFILE_PREFIX}${name}`;

// Message
export const SHOWN_MESSAGES_STORAGE_KEY = (token: string) => `rpr_shown_messages:${token}`;
export const DEFAULT_CLOSE_MESSAGES_BY_IN_PAGE_LINK = true;

// EventChunk
export const DATA_UPLOAD_INTERVAL = 3000;

// ServiceWorker
export const REPRO_CACHE_NAME = 'repro_cache_v1';
export const CACHE_STORE_FETCH_PATH = '/repro/cache';

// Spa Mode
export const DEFAULT_RECONFIGURE_INTERVAL = 1000 * 60 * 3;
export const DEFAULT_CLOSE_MESSAGES_ON_PAGECHANGE = false;
export const DEFAULT_REUSE_MESSAGES_ON_PAGECHANGE = 'none' as const;
export const REUSE_MESSAGES_ON_PAGECHANGE_VALUES = ['none', 'unlimited', 'multitime'] as const;
